import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch,FaPrint, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function ConcesionesTable() {
  const [concesiones, setConcesiones] = useState([]);
  const [filteredConcesiones, setFilteredConcesiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('lugareId');
  const [sortDirection, setSortDirection] = useState('desc');  
  const [selectedTercero, setSelectedTercero] = useState(null); // Nuevo estado
  const [searchSepulturaId, setSearchSepulturaId] = useState('');
  const [pageBlock, setPageBlock] = useState(0); // Cada bloque tiene 10 páginas
  const pagesPerBlock = 10;
  

  useEffect(() => {
    fetchConcesiones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, searchTercero, concesiones, startDate, endDate, sortColumn, sortDirection, searchSepulturaId]);
  


  /*
  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, searchTercero, concesiones,startDate,endDate, sortColumn, sortDirection]);
*/



  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchConcesiones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/concesiones');
      setConcesiones(response.data);
      setFilteredConcesiones(response.data);
    } catch (err) {
      setError('Error al cargar las concesiones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);      
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const handlePrint = async (sepulturaId) => {
    if (!sepulturaId) return;
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Concesion_${sepulturaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };

  const filterAndSortConcesiones = () => {
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (concesion.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === concesion.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        )) &&
      (!startDate || new Date(concesion.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(concesion.fecha) <= new Date(endDate)) &&
      (!searchSepulturaId || concesion.sepulturaId.toString().includes(searchSepulturaId))
    );
  
    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  
    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };
  

/*
  const filterAndSortConcesiones = () => {   
       
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (concesion.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === concesion.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        )) &&
      (!startDate || new Date(concesion.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(concesion.fecha) <= new Date(endDate))
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };
*/

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredConcesiones.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredConcesiones.length / itemsPerPage);
  //const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const startPage = pageBlock * pagesPerBlock;
  const endPage = Math.min(startPage + pagesPerBlock, totalPages);
  const pageNumbers = Array.from({ length: endPage - startPage }, (_, i) => startPage + i + 1);
  



  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Concesiones</h1>
      <div className="flex justify-between mb-4">

      <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>


{/* origen
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>

*/}

        <Link to="/home/concesiones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Concesión
        </Link>
      </div>

      <div className="flex space-x-4 w-full">

 <input
  type="text"
  placeholder="Buscar por Sepultura ID"
  className="border p-2 rounded w-1/5"
  value={searchSepulturaId}
  onChange={(e) => setSearchSepulturaId(e.target.value)}
/>




          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>



      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              {[ 'lugareId', 'tipoId', 'fecha', 'observaciones', 'terceroId', 'sepulturaId', 'serie', 'numero' ].map((col) => (
                <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => setSortColumn(col)}>
                  {col.charAt(0).toUpperCase() + col.slice(1)} {' '}
                  {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                </th>
              ))}
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((concesion) => (
              <tr key={concesion.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{concesion.lugareId}</td>
                <td className="px-6 py-4">{concesion.tipoId}</td>
                <td className="px-6 py-4">{concesion.fecha}</td>
                <td className="px-6 py-4">{concesion.observaciones}</td>
                <td className="px-6 py-4">{concesion.terceroId}</td>
                <td className="px-6 py-4">{concesion.sepulturaId}</td>
                <td className="px-6 py-4">{concesion.serie}</td>
                <td className="px-6 py-4">{concesion.numero}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/concesiones/${concesion.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/concesiones/edit/${concesion.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(concesion.sepulturaId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                                 
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      <div className="flex justify-center items-center mt-4 space-x-2">
  {pageBlock > 0 && (
    <button
      onClick={() => setPageBlock(pageBlock - 1)}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      ← Anteriores
    </button>
  )}
  {pageNumbers.map((number) => (
    <button
      key={number}
      onClick={() => setCurrentPage(number)}
      className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
    >
      {number}
    </button>
  ))}
  {(pageBlock + 1) * pagesPerBlock < totalPages && (
    <button
      onClick={() => setPageBlock(pageBlock + 1)}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      Siguientes →
    </button>
  )}
</div>

      {/* 
      <div className="flex justify-center items-center mt-4 space-x-2">
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number}
          </button>
        ))}
      </div>
      */}



    </div>
    

  );
}


/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch,FaPrint, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function ConcesionesTable() {
  const [concesiones, setConcesiones] = useState([]);
  const [filteredConcesiones, setFilteredConcesiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('lugareId');
  const [sortDirection, setSortDirection] = useState('desc');  
  const [selectedTercero, setSelectedTercero] = useState(null); // Nuevo estado

  useEffect(() => {
    fetchConcesiones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, searchTercero, concesiones,startDate,endDate, sortColumn, sortDirection]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchConcesiones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/concesiones');
      setConcesiones(response.data);
      setFilteredConcesiones(response.data);
    } catch (err) {
      setError('Error al cargar las concesiones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);      
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const handlePrint = async (sepulturaId) => {
    if (!sepulturaId) return;
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Concesion_${sepulturaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };


  const filterAndSortConcesiones = () => {
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (concesion.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === concesion.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        )) &&
      (!startDate || new Date(concesion.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(concesion.fecha) <= new Date(endDate))
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredConcesiones.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredConcesiones.length / itemsPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Concesiones</h1>
      <div className="flex justify-between mb-4">

      <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>

        <Link to="/home/concesiones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Concesión
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>



      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              {[ 'lugareId', 'tipoId', 'fecha', 'observaciones', 'terceroId', 'sepulturaId', 'serie', 'numero' ].map((col) => (
                <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => setSortColumn(col)}>
                  {col.charAt(0).toUpperCase() + col.slice(1)} {' '}
                  {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                </th>
              ))}
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((concesion) => (
              <tr key={concesion.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{concesion.lugareId}</td>
                <td className="px-6 py-4">{concesion.tipoId}</td>
                <td className="px-6 py-4">{concesion.fecha}</td>
                <td className="px-6 py-4">{concesion.observaciones}</td>
                <td className="px-6 py-4">{concesion.terceroId}</td>
                <td className="px-6 py-4">{concesion.sepulturaId}</td>
                <td className="px-6 py-4">{concesion.serie}</td>
                <td className="px-6 py-4">{concesion.numero}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/concesiones/${concesion.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/concesiones/edit/${concesion.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(concesion.sepulturaId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                                 
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center mt-4 space-x-2">
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number}
          </button>
        ))}
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch,FaPrint, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function ConcesionesTable() {
  const [concesiones, setConcesiones] = useState([]);
  const [filteredConcesiones, setFilteredConcesiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('lugareId');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchConcesiones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, searchTercero, concesiones,startDate,endDate, sortColumn, sortDirection]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchConcesiones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/concesiones');
      setConcesiones(response.data);
      setFilteredConcesiones(response.data);
    } catch (err) {
      setError('Error al cargar las concesiones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const handlePrint = async (sepulturaId) => {
    if (!sepulturaId) return;
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Concesion_${sepulturaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };


  const filterAndSortConcesiones = () => {
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (concesion.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === concesion.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        )) &&
      (!startDate || new Date(concesion.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(concesion.fecha) <= new Date(endDate))
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredConcesiones.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredConcesiones.length / itemsPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Concesiones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/concesiones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Concesión
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>



      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              {[ 'lugareId', 'tipoId', 'fecha', 'observaciones', 'terceroId', 'sepulturaId', 'serie', 'numero' ].map((col) => (
                <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => setSortColumn(col)}>
                  {col.charAt(0).toUpperCase() + col.slice(1)} {' '}
                  {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                </th>
              ))}
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((concesion) => (
              <tr key={concesion.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{concesion.lugareId}</td>
                <td className="px-6 py-4">{concesion.tipoId}</td>
                <td className="px-6 py-4">{concesion.fecha}</td>
                <td className="px-6 py-4">{concesion.observaciones}</td>
                <td className="px-6 py-4">{concesion.terceroId}</td>
                <td className="px-6 py-4">{concesion.sepulturaId}</td>
                <td className="px-6 py-4">{concesion.serie}</td>
                <td className="px-6 py-4">{concesion.numero}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/concesiones/${concesion.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/concesiones/edit/${concesion.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(concesion.sepulturaId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                                 
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center mt-4 space-x-2">
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number}
          </button>
        ))}
      </div>
    </div>
  );
}
*/


/* CORRECTO FILTRO TERCEROS
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function ConcesionesTable() {
  const [concesiones, setConcesiones] = useState([]);
  const [filteredConcesiones, setFilteredConcesiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('lugareId');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchConcesiones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, searchTercero, concesiones, sortColumn, sortDirection]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchConcesiones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/concesiones');
      setConcesiones(response.data);
      setFilteredConcesiones(response.data);
    } catch (err) {
      setError('Error al cargar las concesiones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterAndSortConcesiones = () => {
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (concesion.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === concesion.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ))
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredConcesiones.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredConcesiones.length / itemsPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Concesiones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/concesiones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Concesión
        </Link>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              {[ 'lugareId', 'tipoId', 'fecha', 'observaciones', 'terceroId', 'sepulturaId', 'serie', 'numero' ].map((col) => (
                <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => setSortColumn(col)}>
                  {col.charAt(0).toUpperCase() + col.slice(1)} {' '}
                  {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                </th>
              ))}
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((concesion) => (
              <tr key={concesion.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{concesion.lugareId}</td>
                <td className="px-6 py-4">{concesion.tipoId}</td>
                <td className="px-6 py-4">{concesion.fecha}</td>
                <td className="px-6 py-4">{concesion.observaciones}</td>
                <td className="px-6 py-4">{concesion.terceroId}</td>
                <td className="px-6 py-4">{concesion.sepulturaId}</td>
                <td className="px-6 py-4">{concesion.serie}</td>
                <td className="px-6 py-4">{concesion.numero}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/concesiones/${concesion.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/concesiones/edit/${concesion.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center mt-4 space-x-2">
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number}
          </button>
        ))}
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function ConcesionesTable() {
  const [concesiones, setConcesiones] = useState([]);
  const [filteredConcesiones, setFilteredConcesiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('lugareId');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchConcesiones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, searchTercero, concesiones, sortColumn, sortDirection]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchConcesiones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/concesiones');
      setConcesiones(response.data);
      setFilteredConcesiones(response.data);
    } catch (err) {
      setError('Error al cargar las concesiones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterAndSortConcesiones = () => {
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (concesion.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === concesion.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ))
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Concesiones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/concesiones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Concesión
        </Link>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              {[ 'lugareId', 'tipoId', 'fecha', 'observaciones', 'terceroId', 'sepulturaId', 'serie', 'numero' ].map((col) => (
                <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => setSortColumn(col)}>
                  {col.charAt(0).toUpperCase() + col.slice(1)} {' '}
                  {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                </th>
              ))}
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredConcesiones.map((concesion) => (
              <tr key={concesion.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{concesion.lugareId}</td>
                <td className="px-6 py-4">{concesion.tipoId}</td>
                <td className="px-6 py-4">{concesion.fecha}</td>
                <td className="px-6 py-4">{concesion.observaciones}</td>
                <td className="px-6 py-4">{concesion.terceroId}</td>
                <td className="px-6 py-4">{concesion.sepulturaId}</td>
                <td className="px-6 py-4">{concesion.serie}</td>
                <td className="px-6 py-4">{concesion.numero}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/concesiones/${concesion.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/concesiones/edit/${concesion.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function ConcesionesTable() {
  const [concesiones, setConcesiones] = useState([]);
  const [filteredConcesiones, setFilteredConcesiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('lugareId');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchConcesiones();
  }, []);

  useEffect(() => {
    filterAndSortConcesiones();
  }, [searchTerm, concesiones, sortColumn, sortDirection]);

  const fetchConcesiones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/concesiones');
      setConcesiones(response.data);
      setFilteredConcesiones(response.data);
    } catch (err) {
      setError('Error al cargar las concesiones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortConcesiones = () => {
    let filtered = concesiones.filter(concesion =>
      concesion.observaciones.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredConcesiones(sorted);
    setCurrentPage(1);
  };

  const handleDeleteConcesion = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta concesión?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/concesiones/${id}`);
        fetchConcesiones();
      } catch (err) {
        setError('Error al eliminar la concesión. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredConcesiones.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(filteredConcesiones.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Concesiones</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Concesiones</h2>
          <Link
            to="/home/concesiones/add"
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center"
          >
            <FaPlus className="mr-2" /> Añadir Concesión
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-500 text-white">
              <tr>
                {[
                  'lugareId',
                  'tipoId',
                  'fecha',
                  'observaciones',
                  'terceroId',
                  'sepulturaId',
                  'serie',
                  'numero',
                ].map((col) => (
                  <th
                    key={col}
                    className="px-6 py-3 cursor-pointer"
                    onClick={() => handleSort(col)}
                  >
                    {col.charAt(0).toUpperCase() + col.slice(1)}{' '}
                    {sortColumn === col &&
                      (sortDirection === 'asc' ? (
                        <FaSortAmountUp />
                      ) : (
                        <FaSortAmountDown />
                      ))}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((concesion) => (
                <tr key={concesion.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{concesion.lugareId}</td>
                  <td className="px-6 py-4">{concesion.tipoId}</td>
                  <td className="px-6 py-4">{concesion.fecha}</td>
                  <td className="px-6 py-4">{concesion.observaciones}</td>
                  <td className="px-6 py-4">{concesion.terceroId}</td>
                  <td className="px-6 py-4">{concesion.sepulturaId}</td>
                  <td className="px-6 py-4">{concesion.serie}</td>
                  <td className="px-6 py-4">{concesion.numero}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link
                      to={`/home/concesiones/${concesion.id}`}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      <FaEye />
                    </Link>
                    <Link
                      to={`/home/concesiones/edit/${concesion.id}`}
                      className="text-green-600 hover:text-green-900"
                    >
                      <FaEdit />
                    </Link>
                    <button
                      onClick={() => handleDeleteConcesion(concesion.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded ${
                currentPage === index + 1
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200'
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}  

*/